export const FAQ_LIST = [
    {
        title: 'Why can’t I find my account?',
        description: 'Account data is recorded on-chain, but it may take some time to appear on the explorer - especially when the account has just been created. If nothing shows up in your search, please check back again after a short while.',
    },
    {
        title: 'I received NXPC airdrop, but I don’t see it in my wallet.',
        description: 'NXPC airdrops were distributed on the Avalanche C-Chain. Please note that this explorer does not support data from the Avalanche C-Chain, so airdrop transactions made on that chain will not appear here.',
    },
    {
        title: 'I encountered an issue while playing MapleStory N. Where can I get help?',
        description: 'This explorer is a third-party tool designed to help users track on-chain data related to the MapleStory Universe. For any gameplay related issues, please contact the official MapleStory N support team through their website or customer service channels.',
    },
    {
        title: 'Does the explorer support multiple languages?',
        description: 'Currently, the explorer is available in English only. We plan to support more languages in the future and appreciate your patience in the meantime.',
    },
]